import { Locale, K } from "../constants";

const locale: Locale = {
  [K.LAST_AN_HOUR]: "Last 1 hour",
  [K.LAST_24_HOURS]: "Last 24 hours",
  [K.TODAY]: "Today",
  [K.LAST_7_DAYS]: "Last 7 days",
  [K.LAST_30_DAYS]: "Last 30 days",
  [K.SPECIFIED_RANGE]: "Specified range",
  [K.QUICK_SELECTION]: "Quick selection",
  [K.CONFIRM]: "Confirm",
  [K.START_DATE]: "Start date",
  [K.END_DATE]: "End date",
};

export default locale;
